export default __webpack_public_path__ + "static/media/Van.a25fe05f.jpeg";